import { render, staticRenderFns } from "./NotAvailableModal.vue?vue&type=template&id=b04a0290&scoped=true"
import script from "./NotAvailableModal.vue?vue&type=script&lang=js"
export * from "./NotAvailableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04a0290",
  null
  
)

export default component.exports